function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#DB2838",
  d: "M35.515 16.386a.916.916 0 0 1-1.832 0v-4.58a9.161 9.161 0 0 0-18.323 0v4.58a.916.916 0 0 1-1.832 0v-4.58C13.528 5.733 18.45.811 24.52.811c6.072 0 10.994 4.922 10.994 10.993v4.581z"
}), React.createElement("path", {
  fill: "#D12962",
  d: "M4.367 11.805h32.98a3.665 3.665 0 0 1 3.664 3.665v21.987a3.665 3.665 0 0 1-3.664 3.664H4.367a3.665 3.665 0 0 1-3.665-3.664V15.47a3.664 3.664 0 0 1 3.665-3.665z"
}), React.createElement("path", {
  fill: "#B82456",
  d: "M37.347 11.805a3.664 3.664 0 0 1 3.664 3.665v21.987a3.664 3.664 0 0 1-7.329 0V15.47a3.664 3.664 0 0 1 3.665-3.665z"
}), React.createElement("path", {
  fill: "#FF3378",
  d: "M4.367 11.805h25.651a3.665 3.665 0 0 1 3.665 3.665v21.987a3.665 3.665 0 0 1-3.665 3.664H4.367a3.665 3.665 0 0 1-3.665-3.664V15.47a3.664 3.664 0 0 1 3.665-3.665z"
}), React.createElement("g", {
  fill: "#FFF",
  opacity: 0.24,
  transform: "translate(4.31 13.61)"
}, React.createElement("circle", {
  cx: 2.806,
  cy: 2.777,
  r: 2.748
}), React.createElement("circle", {
  cx: 22.961,
  cy: 2.777,
  r: 2.748
})), React.createElement("path", {
  fill: "#FFF",
  d: "M6.199 20.967c1.012 0 1.832.82 1.832 1.832v10.994a1.832 1.832 0 0 1-3.665 0V22.799c0-1.012.82-1.832 1.833-1.832z",
  opacity: 0.24
}), React.createElement("path", {
  fill: "#FF4957",
  d: "M28.186 16.386a.916.916 0 0 1-1.832 0v-4.58a9.161 9.161 0 0 0-18.323 0v4.58a.916.916 0 0 1-1.832 0v-4.58C6.199 5.733 11.12.811 17.192.811c6.072 0 10.994 4.922 10.994 10.993v4.581z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M12.611 13.638h10.994a.916.916 0 0 1 0 1.832H12.61a.916.916 0 1 1 0-1.832z",
  opacity: 0.24
}), React.createElement("path", {
  fill: "#000",
  d: "M31.85 15.47c-1.011 0-1.832.82-1.832 1.832v18.323c0 1.012-.82 1.832-1.832 1.832H6.199a1.832 1.832 0 0 0 0 3.665h23.82a3.665 3.665 0 0 0 3.664-3.665V17.302c0-1.012-.82-1.832-1.832-1.832z",
  opacity: 0.18
}));

var SvgShopping = function SvgShopping(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShopping, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shopping.a238b2b7.svg";
export { ForwardRef as ReactComponent };